export default __webpack_public_path__ + "static/media/rightArrow.5d6a76cb.webp";